import { Paper, Typography, Stack } from "@mui/material";
// import { AttachMoney, LocalOffer } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../ProgramForm/helpers/quotationCalculations";

const ProgramPricing = ({ program }) => {
    const { i18n } = useTranslation();
    const lang = i18n.language;

    // Helper function to get the correct price and currency
    const getDisplayPrice = () => {
        const price = program.display_price || program.price;
        const currency = program.display_currency || program.currency;
        return {
            price: parseFloat(price),
            symbol: currency?.symbol || '฿',
            name: currency?.name?.[lang] || currency?.name?.en || 'THB'
        };
    };

    const { price: finalPrice, symbol } = getDisplayPrice();

    return (
        <Paper 
            className="pricing-section program-price-element"
            sx={{ 
                p: 3, 
                mt: 3,
                '@media print': {
                    pageBreakInside: 'auto',
                    marginTop: '20px',
                }
            }}
        >
            {/* <Typography variant="h6" fontWeight="bold" gutterBottom>
                {lang === 'ar' ? "ملخص الأسعار" : "Pricing Summary"}
            </Typography> */}
            {/* <Divider sx={{ mb: 2 }} /> */}

            <Stack spacing={2}>
                {/* Original Price */}
                {/* <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <AttachMoney fontSize="small" color="action" />
                        <Typography variant="body2" color="text.secondary">
                            {lang === 'ar' ? "السعر الأصلي" : "Original Price"}
                        </Typography>
                    </Stack>
                    <Typography variant="h6" fontWeight="600">
                        ${originalPrice.toFixed(0)}
                    </Typography>
                </Stack> */}

                {/* Discount */}
                {/* {program.discount_type !== "zero" && (
                    <>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack direction="row" spacing={1} alignItems="center">
                                <LocalOffer fontSize="small" color="error" />
                                <Typography variant="body2" color="text.secondary">
                                    {lang === 'ar' ? "الخصم" : "Discount"}
                                </Typography>
                            </Stack>
                            <Chip
                                label={
                                    program.discount_type === "percentage"
                                        ? `${discount}%`
                                        : `$${discount.toFixed(0)}`
                                }
                                color="error"
                                size="small"
                            />
                        </Stack>
                        <Divider />
                    </>
                )} */}

                {/* Final Price */}
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1" fontWeight="bold">
                        {lang === 'ar' ? "السعر الإجمالي" : "Total Price"}
                    </Typography>
                    <Typography variant="h5" fontWeight="bold" color="primary">
                        {symbol} {formatCurrency(finalPrice)} 
                    </Typography>
                </Stack>
            </Stack>
        </Paper>
    );
};

export default ProgramPricing;
